// #### Recipes ####
const ContactRelationshipRecipe = {
    $type$: 'Recipe',
    name: 'ContactRelationship',
    rule: [
        {
            itemprop: 'targetPersonId',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Person']) },
            isId: true
        },
        {
            itemprop: 'relationshipType',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'label',
            itemtype: { type: 'string' },
            optional: true
        }
    ]
};
export default ContactRelationshipRecipe;
//# sourceMappingURL=ContactRelationship-1-0-0.js.map